// Library Methods
import i18next from "i18next";
import { useTranslation } from "react-i18next";

// Components
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import IconButton from "@mui/material/IconButton";
import { PlusIcon } from "src/assets/icons";

import externalExamCardsImg from "src/assets/images/operating-manual/instructions-for-use/external-exam-cards.png";
import externalExamCardsFrImg from "src/assets/images/operating-manual/instructions-for-use/external-exam-cards-fr.png";
import externalProgressionCardsImg from "src/assets/images/operating-manual/instructions-for-use/external-progression-cards.png";
import externalProgressionCardsFrImg from "src/assets/images/operating-manual/instructions-for-use/external-progression-cards-fr.png";

// Styles
import { UI_SIZES } from "src/constants/uiTokens";

// Config
import { priorityLanguageMap } from "src/config/languages";

const ExternalExams = () => {
  const { t } = useTranslation("operating-manual");

  const currentLang = i18next.language as keyof typeof priorityLanguageMap;

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        gap: "20px",
      }}
    >
      <Typography>
        {t(
          "Visual field reports generated from external systems other than RetinaLogik can be uploaded for a patient. External exams can also be used as part of a progression analysis. This feature can be enabled by contacting your system administrator."
        )}
      </Typography>

      <Typography>
        1.{" "}
        {t(
          "Contact the system administrator to upload an external exam report for a patient. Once uploaded, go to the patient you would like to view the report for and click the external exam tab. Any external exams uploaded for that patient will appear here."
        )}
      </Typography>

      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
        }}
      >
        <img
          src={
            currentLang === "fr" ? externalExamCardsFrImg : externalExamCardsImg
          }
          width="75%"
          alt="external-exam-cards"
        />
      </Box>

      <Typography>
        2.{" "}
        {t(
          "To add an external exam to a progression analysis, go to the patient you would like to generate a progression analysis report for, and click the progression analysis tab. Ensure your administrator has uploaded the exam."
        )}
      </Typography>

      <Typography>
        3. {t("Click the ")}
        <IconButton
          sx={{
            width: `${UI_SIZES.iconButtonSize}px`,
            height: `${UI_SIZES.iconButtonSize}px`,
            color: "#FFF",
            backgroundColor: "#202338",
            borderRadius: "4px",
            pointerEvents: "none",
          }}
        >
          <PlusIcon />
        </IconButton>
        {t(" Add button.")}
      </Typography>

      <Typography>
        4.{" "}
        {t(
          "Select the eye and exams you would like to generate a progression analysis for. External exams will be labelled as 'external'. Click the Generate button."
        )}
      </Typography>

      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
        }}
      >
        <img
          src={
            currentLang === "fr"
              ? externalProgressionCardsFrImg
              : externalProgressionCardsImg
          }
          width="75%"
          alt="external-progression-cards"
        />
      </Box>
    </Box>
  );
};

export default ExternalExams;
